import triangleGenerator from './triangle-generator.svg';
import colorShadesGenerator from './color-shades-generator.svg';
import padeDividers from './page-dividers.svg';
import svgCompressor from './svg-compressor.svg';
import svg2jsx from './svg-to-jsx.svg';
import htmlSymbols from './html-symbols.svg';
import loremIpsum from './lorem-ipsum.svg';
import b64encoding from './b64-encoding.svg';
import fakeDataGenerator from './fake-data-generator.svg';
import cssCursors from './css-cursors.svg';
import eventsKeycode from './events-keycode.svg';
import gradientGenerator from './gradient-generator.svg';
export default {
    '/triangle-generator': triangleGenerator,
    '/color-shades-generator': colorShadesGenerator,
    '/page-dividers': padeDividers,
    '/svg-compressor': svgCompressor,
    '/svg-to-jsx': svg2jsx,
    '/html-symbols': htmlSymbols,
    '/lorem-ipsum': loremIpsum,
    '/b64-encoding': b64encoding,
    '/fake-data-generator': fakeDataGenerator,
    '/css-cursors': cssCursors,
    '/events-keycode': eventsKeycode,
    '/gradient-generator': gradientGenerator,
};
